import { useEffect, useCallback, useState } from 'react';
import { useLocation, useParams, generatePath } from 'quartz-routing/react-router';
import { useACNavigate } from 'academy-common-lib/hooks/useACNavigate';
import { Flex } from 'foundations-components/components/Flex';
import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { ModalDialog } from 'foundations-components/transitional/components/ModalDialog';
import { AcademyAIAssistantChatContainer } from 'academy-ai-assistant-lib/components/AcademyAIAssistantChatContainer';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { AC_ASSISTANT_URL_FRAGMENT } from 'academy-common-lib/routes/academyRoutePaths';
import { AcademyCompactNav } from '../features/navigation/components/AcademyCompactNav';
import UsageTracker from '../utils/UsageTracker';
import { SCREENS } from '../constants/Tracking.migrated';
import { NavMarker } from 'react-rhumb';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AcademyAssistant = () => {
  var _location$state;
  const {
    isMobile,
    isMobileNavbar
  } = useMediaQuery();
  const navigate = useACNavigate();
  const location = useLocation();
  const {
    conversationId: conversationIdParam
  } = useParams();
  const conversationId = conversationIdParam != null ? Number(conversationIdParam) : null;
  const [initialPrompt] = useState(() => {
    var _URLSearchParams$get;
    return (_URLSearchParams$get = new URLSearchParams(location.search).get('initialPrompt')) !== null && _URLSearchParams$get !== void 0 ? _URLSearchParams$get : undefined;
  });
  useEffect(() => {
    if (new URLSearchParams(location.search).get('initialPrompt')) {
      navigate({
        pathname: location.pathname,
        search: ''
      }, {
        replace: true
      });
    }
  }, [navigate, location.pathname, location.search]);
  useEffect(() => {
    UsageTracker.trackStandalone('Pageview', {
      screen: SCREENS.ACADEMY_ASSISTANT
    });
  }, []);
  const handleClose = useCallback(() => {
    navigate('/');
  }, [navigate]);
  const handleConversationChange = useCallback(id => {
    navigate(generatePath(AC_ASSISTANT_URL_FRAGMENT, {
      conversationId: id !== null && id !== void 0 ? id : undefined
    }), {
      replace: true
    });
  }, [navigate]);
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "ACADEMY_ASSISTANT_LOADED",
    children: /*#__PURE__*/_jsx(ModalDialog, {
      "data-test-id": "academy-assistant-modal",
      use: "fullscreen",
      children: /*#__PURE__*/_jsxs(Flex, {
        blockSize: "100%",
        flexDirection: "column",
        overflow: "hidden",
        children: [!isMobileNavbar && /*#__PURE__*/_jsx(AcademyCompactNav, {}), /*#__PURE__*/_jsx(Flex, {
          backgroundColor: "fill-surface-recessed",
          flexDirection: "column",
          flexGrow: 1,
          minBlockSize: "0",
          overflow: "hidden",
          padding: isMobile ? '500' : '400',
          children: /*#__PURE__*/_jsx(CardWrapper, {
            borderRadius: "400",
            borderWidth: "0",
            flexGrow: 1,
            marginBlockEnd: "0",
            minBlockSize: "0",
            padding: isMobile ? '200' : '400',
            children: /*#__PURE__*/_jsx(AcademyAIAssistantChatContainer, {
              conversationId: conversationId,
              initialPrompt: initialPrompt,
              onClose: handleClose,
              onConversationChange: handleConversationChange,
              openHistoryOnMount: !!((_location$state = location.state) !== null && _location$state !== void 0 && _location$state.openHistory)
            })
          })
        })]
      })
    })
  });
};
export default AcademyAssistant;